import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import logo from '../Assets/img/RqcLogo.png';
import { NavLink } from 'react-router-dom'; 
import '../Assets/css/navbar.css'

function NavigationBar() {
  return (
      <Navbar expand="lg" className="bg-body-tertiary">
      <Container>
        <Navbar.Brand href="/">
            <div className="brand-container">
                <img
                    src={logo}
                    alt="Logo"
                    height="100"
                    className="d-inline-block align-top"
                />
                {/* <span className="brand-text text-wrap text-truncate">Réseaux Québec Communication</span> */}
            </div>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={NavLink} to="/" end>Accueil</Nav.Link>
            {/* <Nav.Link as={NavLink} to="/Services" end>Nos Services</Nav.Link> */}
            <Nav.Link as={NavLink} to="/Contact" end>Contact</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavigationBar;